import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CaseIcon from '@mui/icons-material/WorkOutline';
import Grid from "@mui/material/Grid";
import ListIcon from '@mui/icons-material/List';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonIcon from '@mui/icons-material/Person';
import Typography from '@mui/material/Typography';

import {formatCaseName, formatCaseBillingType} from '../../helpers/cases';
import {formatPatientName} from '../../helpers/patients';
import {formatProviderName} from '../../helpers/providers';
import CustomCard from '../common/CustomCard';
import CaseStatus from './CaseStatus';
import EditCaseButton from './EditCaseButton';

const getButtons = ({caseData}) => ([
  <EditCaseButton caseId={caseData.id} variant='outlined'/>
  // <SchedulePatientButton patient={patient} variant='outlined' fullWidth color='primary' textOnly={true}/>,
  // <MessageUserButton patient={patient} variant='outlined' fullWidth color='primary' textOnly={true}/>,
]);

const CaseCard = props => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const {caseData: c} = props;
  if (!c) {
    return <></>;
  }

  return (
    <Box key={c.id}>
      <CustomCard listItems={[
        {
          // Icon: (() => <SvgIcon component={PersonIcon} style={{color: 'var(--text)', fontSize: '1.25rem'}} inheritViewBox/>),
          Icon: PersonIcon,
          text: (
            <Grid container alignItems='center' justifyItems='center' spacing={0}>
              <Grid item xs={9} paddingRight="0.5rem">
                <Typography className="card-title text-ellipsis">
                  {formatPatientName(c.patient)}
                </Typography>
              </Grid>
              <Grid item xs={3} display="flex" alignItems='center' justifyContent="end">
                <CaseStatus case={c} />
              </Grid>
            </Grid>
          ),
          key: 'name',
        },
        {
          Icon: CaseIcon,
          text: formatCaseName(c),
          key: 'case_name',
        },
        {
          Icon: PaymentIcon,
          text: formatCaseBillingType(c),
          key: 'case_name',
        },
        {
          Icon: LocalHospitalIcon,
          text: (c.providers || []).map(p => formatProviderName(p)).join(', '),
          key: 'providers',
        },
        {
          Icon: ListIcon,
          text: (
            <Button type='text' size='small' onClick={() => navigate(`/providers/sessions?case_id=${c.id}`)}>
              View {c.session_count} session{c.session_count === 1 ? '' : 's'}
            </Button>
          ),
          key: 'session_count',
        }
      ]} noTopBorder buttons={getButtons({caseData: c})} passButtonChildren={true}/>
    </Box>
  );
};

export default CaseCard;
